module.exports = __webpack_public_path__ + "static/media/profile-picture-543w.b7b74e8c.webp";